import styled from '@emotion/styled';
import { rem } from '@utils';

const Location = styled.span`
  cursor: help;
  text-decoration: underline;

  & + & {
    margin-left: ${rem(4)};
  }

  &:hover {
    color: ${({ theme }) => theme.palette.primary.main};
  }
`;

const DialogContent = styled.div`
  font-size: ${rem(14)};
  line-height: ${rem(18)};
}
`;

const DefinitionList = styled.dl`
  margin-top: ${rem(16)};
`;

const DefinitionTitle = styled.dt`
  font-weight: 600;
  margin-bottom: ${rem(4)};
`;

const DefinitionDetails = styled.dd`
  &:not(:last-of-type) {
    margin-bottom: ${rem(16)};
  }
`;

const FooterButton = styled.span`
  display: block;
  margin-left: auto;

  .button {
    font-weight: 600;
  }
`;

const CloseButton = styled.div`
  border-radius: 4px;
  cursor: pointer;
  height: ${rem(32)};
  transition: 200ms;
  
  &:active {
    background: ${({ theme }) => theme.palette.primary.dark};
    
    * {
      fill: ${({ theme }) => theme.palette.common.white};
    }
  }
`;

const CaptionItem = styled.div`
  display: inline;
  font-size: ${rem(12)};
  line-height: ${rem(16)};

  * {
    display: inherit;
  }

  & + & {
    margin-left: ${rem(4)};
  }

  .caption-item + .caption-item {
    margin-left: ${rem(4)};
  }
`;

export default {
  CaptionItem,
  DialogContent,
  Location,
  FooterButton,
  DefinitionList,
  DefinitionTitle,
  DefinitionDetails,
  CloseButton
};
